import { ICommand } from 'core-ts-types';
import { largeCourseGroupCommonState } from '../../ap_plan_routes';
import { AdvisorSmartCatalogRoutes } from '../../ap_smart_catalog_routes';
import { FeedbackSuggestedPlanModel } from './../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

export const AdvisorPlannerEditRoutes = {
  'ap-advisor.plan.edit': {
    url: 'edit/',
    views: {
      '@ap-advisor': {
        template: `<ap-planner is-editable="true"></ap-planner>`
      },
      'terms@ap-advisor.plan.edit': {
        template: `<ap-planner-terms is-editable="true"></ap-planner-terms>`
      },
      'advisor-imp-student-banner@ap-advisor.plan.edit': {
        template: `<advisor-edit-plan-header></advisor-edit-plan-header>`
      }
    },
    resolve: {
      flaggedCourses: (
        loadCommentCommand: ICommand,
        academicPlan: any,
        ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
      ) => loadCommentCommand(`/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/comment/`)
    }
  },
  'ap-advisor.plan.edit.default': {
    url: 'default/',
    data: {
      academicPlanUrl: 'reg/advisorplan',
      pageTitle: 'Edit plan'
    },
    views: {
      'default@ap-advisor.plan.edit': {
        template: '<ap-planner-resources is-editable="true"></ap-planner-resources>'
      }
    }
  },
  'ap-advisor.plan.edit.coursegroup': <ng.ui.IState>{
    ...largeCourseGroupCommonState,
    views: {
      'largeCourseGroup@ap-advisor.plan.edit': {
        template: '<large-course-group query="$resolve.query" is-editable="true"></large-course-group>'
      },
      'advisor-imp-student-banner@ap-advisor.plan.edit': {
        template: `<advisor-edit-plan-header></advisor-edit-plan-header>`
      }
    }
  },
  'ap-advisor.plan.edit.compare': <ng.ui.IState>{
    url: 'compare/',
    views: {
      '@ap-advisor': {
        template: '<student-plan-comparison></student-plan-comparison>'
      },
      'advisor-imp-student-banner@ap-advisor.plan.edit.compare': {
        template: `<advisor-edit-plan-header return-to-edit-button="true"></advisor-edit-plan-header>`
      }
    },
    data: {
      pageTitle: 'Compare'
    }
  },
  'ap-advisor.plan.edit.default.smart_course_details': {
    ...AdvisorSmartCatalogRoutes['ap-advisor.plan.edit.default.smart_course_details']
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/planner/ap_advisor_planner_edit_routes.ts